import { useId } from 'react'
import IconContainer from '@/components/IconContainer'

export default function IconColorSortArrowUp(props) {
  const id = useId()
  return (
    <IconContainer
      {...props}
      width="6"
      height="3"
      ariaLabel="Sort Arrow Up Icon"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M3 0L6 3L0 3L3 0Z" fill={`url(#${id})`} />
      <defs>
        <linearGradient
          id={id}
          x1="6"
          y1="1.74107"
          x2="-0.000118146"
          y2="1.76488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B6AFF" />
          <stop offset="1" stopColor="#39D0D8" />
        </linearGradient>
      </defs>
    </IconContainer>
  )
}
